'use es6';

export const DRILLDOWN_CLOSED = 'DRILLDOWN_CLOSED';
export const DRILLDOWN_OPENED = 'DRILLDOWN_OPENED';
export const DRILLDOWN_BACKTRACK = 'DRILLDOWN_BACKTRACK';
export const STARTED_GROUPING = 'STARTED_GROUPING';
export const SELECTED_GROUPING = 'SELECTED_GROUPING';
export const REMOVED_GROUPING = 'REMOVED_GROUPING';
export const CANCELLED_GROUPING = 'CANCELLED_GROUPING';
export const DRILLDOWN_SAVE_REPORT_COMPLETED = 'DRILLDOWN_SAVE_REPORT_COMPLETED';
export const DRILLDOWN_PAGINATE = 'DRILLDOWN_PAGINATE';